import DigestTemplates from './DigestTemplates';

export default DigestTemplates;